<template>
    <div>
        <div class="hour-progress">
            <div class="bar" :class="barClass" :style="{width: percent + '%'}"></div>
        </div>
        <div class="progress-meta">{{ label || (allocated + ' of ' + target + ' hours allocated') }}</div>
    </div>
</template>

<script>
    /**
     * Props-driven allocation bar (the bundle builder's PackageProgress reads
     * the package store instead). Full = green, over = red.
     */
    export default {
        name: "HourProgress",
        props: {
            target: {type: Number, default: 0},
            allocated: {type: Number, default: 0},
            label: {type: String, default: null}
        },
        computed: {
            remaining() {
                return this.target - this.allocated;
            },
            percent() {
                if (!this.target) return 0;
                return Math.min(100, (this.allocated / this.target) * 100);
            },
            barClass() {
                if (this.remaining < 0) return 'is-over';
                if (this.remaining === 0 && this.target) return 'is-full';
                return '';
            }
        }
    };
</script>

<style lang="scss" scoped>
    .hour-progress {
        height: 8px;
        background: #e6ebf1;
        border-radius: 999px;
        overflow: hidden;

        .bar {
            height: 100%;
            border-radius: 999px;
            background: #366ea5;
            transition: width 150ms;

            &.is-full {
                background: #2e7d4f;
            }

            &.is-over {
                background: #c0392b;
            }
        }
    }

    .progress-meta {
        font-size: 0.75rem;
        color: #7a8a9d;
        margin-top: 0.4rem;
    }
</style>
